import { writable } from 'svelte/store';
import { api } from '../framework/js/api.js';

/**
 * @type {any}
 */
export let briefStoreInitial;

async function fetchBriefsAndUpdateStore(search = '', sortField = 'generated', sortDirection = 'desc') {
  const response = await api.getXploritBriefs(search, sortField, sortDirection);
  if (!response.success) {
      return;
  }
  briefStoreInitial = response.data.list;
  BriefStore.set(briefStoreInitial);
}

export async function loadBriefs(search = '', sortField = 'generated', sortDirection = 'desc') {
  await fetchBriefsAndUpdateStore(search, sortField, sortDirection);
}

export const BriefStore = writable(briefStoreInitial || []);